import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-live-status',
  templateUrl: './live-status.component.html',
  styleUrls: ['./live-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LiveStatusComponent {
  @Input() connected = false;
}
